// src/pages/auth/RegisterThree.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import api from "../../../core/api/config";
// Removendo a importação não utilizada
// import termoService from "../../../core/api/termoService";
import { all_routes } from "../../../core/router/all_routes";
import GovHeader from "../../components/GovHeader";
import { cpf as cpfValidator } from "cpf-cnpj-validator";
import InputMask from "react-input-mask";
import BotaoAjuda from "../../components/BotaoAjuda";
import TermoModal from "../components/TermoModal";
import { useTermo } from "../hooks/useTermo";

const RegisterThree = () => {
  const route = all_routes;
  const navigate = useNavigate();

  const { showTermoModal, closeTermoModal, setShowTermoModal } = useTermo();

  const [step, setStep] = useState(1);
  const [municipios, setMunicipios] = useState([]);
  const [selectedMunicipio, setSelectedMunicipio] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmpassword: "",
    cpf: "",
    cidade_id: null,
    aceite_do_termo: false,
    data_do_termo: null,
  });

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmpassword: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  useEffect(() => {
    const fetchMunicipios = async () => {
      try {
        const res = await api.get("/api/cidade/list");
        const municipioArray = Array.isArray(res.data.data)
          ? res.data.data
          : Array.isArray(res.data.data?.data)
            ? res.data.data.data
            : [];

        const options = municipioArray.map((item) => ({
          value: item.codigo_municipio,
          label: item.municipio,
        }));

        setMunicipios(options);
      } catch (err) {
        console.error("Erro ao carregar municípios", err);
      }
    };

    fetchMunicipios();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAcceptTerm = async () => {
    try {
      setIsSubmitting(true);

      // Fazer o cadastro com o aceite do termo
      const payload = {
        ...formData,
        cpf: formData.cpf.replace(/\D/g, ""),
        aceite_do_termo: true,
        data_do_termo: new Date().toISOString(),
      };

      await api.post("/api/register", payload);

      localStorage.setItem(
        "mensagemCadastro",
        "Cadastro realizado com sucesso! Você será vinculado após análise do município.",
      );
      navigate(route.signin);
    } catch (error) {
      console.error("Erro no cadastro:", error);
      let formattedErrors = {};
      let stepToGo = 1;

      if (error.response && error.response.data && error.response.data.errors) {
        formattedErrors = {};
        Object.keys(error.response.data.errors).forEach((key) => {
          formattedErrors[key] = error.response.data.errors[key];
        });

        if (
          formattedErrors.name ||
          formattedErrors.email ||
          formattedErrors.cpf
        ) {
          stepToGo = 1;
        } else if (formattedErrors.cidade_id) {
          stepToGo = 2;
        } else if (
          formattedErrors.password ||
          formattedErrors.confirmpassword
        ) {
          stepToGo = 3;
        }
      } else {
        formattedErrors = {
          general: "Erro ao realizar cadastro. Tente novamente.",
        };
      }

      setErrors({
        general: "Corrija os erros abaixo para continuar.",
        ...formattedErrors,
      });

      setStep(stepToGo);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setIsSubmitting(false);
      closeTermoModal();
    }
  };

  const validateStep = () => {
    const newErrors = {};

    if (step === 1) {
      if (!formData.name) newErrors.name = ["Nome completo é obrigatório"];
      else if (formData.name.length < 5)
        newErrors.name = ["Nome deve ter pelo menos 5 caracteres"];

      if (!formData.email) newErrors.email = ["Email é obrigatório"];
      else if (!/\S+@\S+\.\S+/.test(formData.email))
        newErrors.email = ["Email deve ser um endereço válido"];

      if (!formData.cpf) newErrors.cpf = ["CPF é obrigatório"];
      else if (!cpfValidator.isValid(formData.cpf))
        newErrors.cpf = ["CPF inválido"];
    }

    if (step === 2) {
      if (!formData.cidade_id)
        newErrors.municipio = ["Município é obrigatório"];
    }

    if (step === 3) {
      if (!formData.password) newErrors.password = ["Senha é obrigatória"];
      else if (formData.password.length < 8)
        newErrors.password = ["Senha deve ter pelo menos 8 caracteres"];

      if (!formData.confirmpassword)
        newErrors.confirmpassword = ["Confirmação de senha é obrigatória"];
      else if (formData.confirmpassword !== formData.password)
        newErrors.confirmpassword = ["As senhas não coincidem"];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => validateStep() && setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const handleFinalSubmit = () => {
    const isValid = validateStep();
    if (!isValid) return;

    // Mostra o modal do termo antes de cadastrar
    setShowTermoModal(true);
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <GovHeader />
        <div className="login-wrapper login-new">
          <div className="login-content user-login">
            <div className="login-logo">
              <img src="/assets/img/logo.png" alt="Logotipo ConeCta-SP" />
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="login-userset">
                <div className="login-userheading">
                  <h3>Faça parte do ConeCta-SP</h3>
                  <h4>Crie sua conta agora mesmo</h4>
                </div>

                {errors.general && (
                  <div className="alert alert-danger">{errors.general}</div>
                )}

                {/* Etapa 1 - Dados pessoais */}
                {step === 1 && (
                  <>
                    <div className="form-login">
                      <label>Nome completo: *</label>
                      <input
                        type="text"
                        name="name"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Digite seu nome completo"
                      />
                      {errors.name && (
                        <small className="text-danger">{errors.name[0]}</small>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-login">
                          <label>E-mail: *</label>
                          <input
                            type="email"
                            name="email"
                            className={`form-control ${
                              errors.email ? "is-invalid" : ""
                            }`}
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="seu@email.com"
                          />
                          {errors.email && (
                            <small className="text-danger">
                              {errors.email[0]}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-login">
                          <label>CPF: *</label>
                          <InputMask
                            mask="999.999.999-99"
                            value={formData.cpf}
                            onChange={handleChange}
                          >
                            {(inputProps) => (
                              <input
                                {...inputProps}
                                name="cpf"
                                className={`form-control ${
                                  errors.cpf ? "is-invalid" : ""
                                }`}
                                placeholder="000.000.000-00"
                              />
                            )}
                          </InputMask>
                          {errors.cpf && (
                            <small className="text-danger">
                              {errors.cpf[0]}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn btn-primary w-100 mt-2"
                      onClick={nextStep}
                    >
                      Próximo
                    </button>
                  </>
                )}

                {/* Etapa 2 - Local */}
                {step === 2 && (
                  <>
                    <div className="form-login">
                      <label>Município: *</label>
                      <Select
                        classNamePrefix="react-select"
                        placeholder="Selecione um município ..."
                        options={municipios}
                        value={selectedMunicipio}
                        onChange={(selected) => {
                          setSelectedMunicipio(selected);
                          setFormData({
                            ...formData,
                            cidade_id: Number(selected.value),
                          });
                        }}
                      />
                      {errors.municipio && (
                        <small className="text-danger">
                          {errors.municipio[0]}
                        </small>
                      )}
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-6">
                        <button
                          type="button"
                          className="btn btn-outline-secondary w-100"
                          onClick={prevStep}
                        >
                          Voltar
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={nextStep}
                        >
                          Próximo
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {/* Etapa 3 - Senha */}
                {step === 3 && (
                  <>
                    <div className="form-login">
                      <label>Senha</label>
                      <div className="pass-group">
                        <input
                          type={
                            passwordVisibility.password ? "text" : "password"
                          }
                          className="form-control"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          placeholder="Mínimo 8 caracteres"
                          required
                        />
                        <span
                          className={`fas toggle-password ${
                            passwordVisibility.password
                              ? "fa-eye"
                              : "fa-eye-slash"
                          }`}
                          onClick={() => togglePasswordVisibility("password")}
                        ></span>
                      </div>
                      {errors.password && (
                        <small className="text-danger">
                          {errors.password[0]}
                        </small>
                      )}
                    </div>

                    <div className="form-login">
                      <label>Confirmar senha</label>
                      <div className="pass-group">
                        <input
                          type={
                            passwordVisibility.confirmpassword
                              ? "text"
                              : "password"
                          }
                          className="form-control"
                          name="confirmpassword"
                          value={formData.confirmpassword}
                          onChange={handleChange}
                          placeholder="Digite a senha novamente"
                          required
                        />
                        <span
                          className={`fas toggle-password ${
                            passwordVisibility.confirmpassword
                              ? "fa-eye"
                              : "fa-eye-slash"
                          }`}
                          onClick={() =>
                            togglePasswordVisibility("confirmpassword")
                          }
                        ></span>
                      </div>
                      {errors.confirmpassword && (
                        <small className="text-danger">
                          {errors.confirmpassword[0]}
                        </small>
                      )}
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <button
                          type="button"
                          className="btn btn-outline-secondary w-100"
                          onClick={prevStep}
                        >
                          Voltar
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button
                          className="btn btn-primary w-100"
                          onClick={handleFinalSubmit}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Cadastrando..." : "Cadastrar"}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>

            <div className="signinform mt-3">
              <h4>
                Já possui uma conta?{" "}
                <Link to={route.signin} className="hover-a">
                  Entrar
                </Link>
              </h4>
            </div>

            <div className="login-logo mt-3">
              <img
                src="/assets/img/logo-fosp.png"
                alt="Logotipo FOSP"
                width="100px"
              />
            </div>
          </div>
        </div>
        <BotaoAjuda />
      </div>

      {/* Modal do Termo de Confidencialidade */}
      <TermoModal
        show={showTermoModal}
        onClose={closeTermoModal}
        onAccept={handleAcceptTerm}
        loading={isSubmitting}
        userNeedsToAcceptTerm={true}
        title="Termo de Confidencialidade"
      />
    </div>
  );
};

export default RegisterThree;
